import _toConsumableArray from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import FetchError from "../services/api/FetchError";
export default {
  props: {
    fetchPage: {
      required: true,
      type: Function
    }
  },
  data: function data() {
    return {
      currentPage: 1,
      hasNoData: false,
      hasMore: true,
      preventFromFetch: false,
      FetchError: FetchError,
      items: [],
      error: null
    };
  },
  methods: {
    refresh: function refresh() {
      this.currentPage = 1;
      this.hasNoData = false;
      this.items = [];
      this.hasMore = true;
      this.preventFromFetch = false;
    },
    onRequestPage: function onRequestPage($state) {
      var _this = this;

      if (this.preventFromFetch === true || !this.hasMore) {
        $state.complete();
        return;
      }

      this.preventFromFetch = true;
      var fetchPageAction = this.fetchPage(this.currentPage);

      if (fetchPageAction instanceof Promise) {
        fetchPageAction.then(function (_ref) {
          var _this$items;

          var items = _ref.data,
              meta = _ref.meta,
              additional = _ref.additional;
          var per_page = 0,
              last_page = 0;

          if (meta) {
            per_page = meta.per_page;
            last_page = meta.last_page;
          } else if (additional && additional.paginator) {
            per_page = additional.paginator.per_page;
            last_page = additional.paginator.last_page;
          }

          _this.error = null;
          if (_this.currentPage === 1 && items.length === 0) _this.hasNoData = true;
          _this.currentPage++;
          _this.hasMore = _this.currentPage <= (last_page || 1);

          (_this$items = _this.items).push.apply(_this$items, _toConsumableArray(items));

          _this.preventFromFetch = false;

          if (per_page < items.length) {
            $state.loaded();
          } else {
            $state.complete();
          }
        }).catch(function (err) {
          _this.error = err;
        });
      } else {
        $state.complete();
      }
    },
    deleteItem: function deleteItem(item) {
      this.items = this.items.filter(function (el) {
        return el.id !== item.id;
      });

      if (this.items.length === 0) {
        this.hasNoData = true;
      }
    },
    createItem: function createItem(item) {
      this.items.unshift(item);
      this.hasNoData = false;
    }
  },
  name: "UnlimitedList"
};